//@formatter:off
/**
 * @ngdoc filter
 * @name words
 * @module portaro.filters
 * @kind function
 *
 * @param {string} input Input string
 * @param {number} maxWords Maximum count of words
 *
 * @return {string} Cropped string.
 *
 * @description
 * Filter limits maximum words in input string. If count of words is bigger than given maxCount, rest of string is deleted and `...` are added at the end.
 *
 * @example
 * <example module="wordsFilterExample" name="wordsFilterExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-init="input = 'Hello world!'; maxCount = 1">
            <div>
                <label for="input">Input string: </label>
                <input id="input" type="text" ng-model="input">
            </div>
            <div>
                <label for="maxCount">Input string: </label>
                <input id="maxCount" type="number" ng-model="maxCount">
            </div>
            <div>
                Output: {{input | words : maxCount}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('wordsFilterExample', ['portaro.filters']);
    </file>
 * </example>
 */
 //@formatter:on
export default function wordsFilter() {
    return (input, maxWords) => {
        if (isNaN(maxWords))
            return input;
        if (maxWords <= 0)
            return '';
        if (input) {
            const inputWords = input.split(/\s+/);
            if (inputWords.length > maxWords) {
                input = inputWords.slice(0, maxWords).join(' ') + '...';
            }
        }
        return input;
    };
};

wordsFilter.filterName = 'words';